<template>
  <section class="easySearch">
    <h2 class="easySearch_heading">カンタン研修病院検索</h2>
    <p class="easySearch_count">
      病院掲載件数
      <em>{{ numberFormatAddComma(count) }}</em>
      件
    </p>
    <ul class="easySearch_buttons">
      <li>
        <button type="button" class="easySearch_button" @click="open('genre')">
          <em>病院種別</em>を選ぶ
        </button>
      </li>
      <li>
        <button
          type="button"
          class="easySearch_button"
          @click="open('location')"
        >
          <em>病院所在地</em>を選ぶ
        </button>
      </li>
    </ul>
  </section>
</template>

<script lang="ts">
import { SetupContext } from 'vue'
import { numberFormatAddComma } from '@/utils/commonMethods'

export default {
  name: 'HomeEasySearch',

  props: {
    count: {
      type: Number,
      default: 0
    }
  },

  setup(props: any, context: SetupContext) {
    const open = (type: string) => {
      context.emit('click-btn', type)
    }

    return {
      open,
      numberFormatAddComma
    }
  }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.easySearch {
  // padding-top: 30px;
  // padding-bottom: 40px;
  text-align: center;
}

.easySearch_heading {
  font-size: 2.2rem;
  font-weight: 500;
  margin-bottom: 10px;
  color: var.$color-main-text;
}

.easySearch_count {
  margin-top: 3px;
  padding-top: 8px;
  padding-bottom: 8px;
  background-color: var.$color-secondary;
  border-radius: 8px 8px 0 0 / 8px 8px 0 0;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;

  @include mixins.media() {
    padding-top: 12px;
    padding-bottom: 12px;
  }

  em {
    font-size: 2.9rem;
    font-weight: 600;
    font-style: normal;
    color: var.$color-primary;
  }
}

.easySearch_buttons {
  display: flex;
  padding: 18px 15px;
  border: 1px solid var.$color-secondary;
  border-top: none;
  border-radius: 0 0 8px 8px / 0 0 8px 8px;

  @include mixins.media() {
    flex-direction: column;
    align-items: center;
    padding: 30px 15px;
  }

  > li {
    flex-basis: 50%;
    flex-grow: 1;

    @include mixins.media() {
      width: 320px;
    }

    &:first-child {
      margin-right: 40px;

      @include mixins.media() {
        margin-right: 0;
      }
    }

    &:not(:first-child) {
      position: relative;

      @include mixins.media() {
        margin-top: 50px;
      }

      &::before,
      &::after {
        position: absolute;
        top: 30px;
        left: -29px;
        display: inline-block;
        content: '';
        width: 18px;
        height: 2px;
        background-color: #ccc;

        @include mixins.media() {
          top: -25px;
          left: 150px;
        }
      }
      &::before {
        transform: rotate(45deg);
      }

      &::after {
        transform: rotate(-45deg);
      }
    }
  }
}

.easySearch_button {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 66px;
  background-color: var.$color-main;
  border-radius: 8px;
  color: #fff;
  text-align: center;
  font-size: 1.2rem;
  font-weight: 600;
  line-height: 1;

  &:hover {
    opacity: 1;
    background-color: #27b7af;
  }

  @include mixins.media() {
    flex-direction: row;
  }

  em {
    margin-bottom: 5px;
    font-style: normal;
    font-size: 1.6rem;
    color: #fffccb;
  }
}
</style>
